import { Injectable } from '@angular/core'
import { PvsRequestFactoryService } from './pvs-request-factory.service'
import { ApiPath } from '../../config/global-const'
import { SharedService } from './shared.service'
import { da } from 'date-fns/locale'

@Injectable({
    providedIn: 'root',
})
export class EmployeeService {
    constructor(private requestService: PvsRequestFactoryService, private sharedService: SharedService) {}

    public getEmployeeList(params = {}) {
        const p = {
            orderBy: 'id|desc',
            ...params,
        }
        const url = this.requestService.createUrl(ApiPath.EMPLOYEES.PATH)
        return this.requestService.requestGet(url, p)
    }

    public createNew(data, avatarFile?: File) {
        const url = this.requestService.createUrl(ApiPath.EMPLOYEES.FORM_STRINGIFY.PATH)
        const formData = this.requestService.buildFormStringify(data, avatarFile, 'avatar')
        return this.requestService.requestPost(url, formData, true)
    }

    public updateSingle(data, avatarFile?: File) {
        const url = this.requestService.createUrl(ApiPath.EMPLOYEES.FORM_STRINGIFY.PATH)
        const formData = this.requestService.buildFormStringify(data, avatarFile, 'avatar')
        return this.requestService.requestPut(url, formData, true)
    }
}
